import styles from './ThreeDots.module.scss';

export const ThreeDots = () => <div className={styles.container} data-testid="three-dots" />;
